module.exports = "query GetCreditsBalance {\n  account {\n    credits {\n      ...AmountFragment\n    }\n  }\n}\n"